import MethodLabelsList from './MethodLabelsList';

export default MethodLabelsList;